import { MODE_WANTS, type RoomMode } from '../meta/online/live';

/**
 * How the screens name each room mode (docs/LIVE.md, HEAD_TO_HEAD.md, SOCCER_MATCH.md,
 * ROUNDUP_MATCH.md, MAZE_MATCH.md): the lobby's and the invite card's "wants ..." line, the mode's short name
 * (the lobby's size line and the inbox), what starts when the host presses START, and the words
 * of a shared link (`size`: quick, normal or long).
 */
export const MODE_WORDS: Record<
  RoomMode,
  { wants: string; name: string; match: string; share: (size: string) => string }
> = {
  race: {
    wants: MODE_WANTS.race,
    name: 'race',
    match: 'race',
    share: (size) => `Race me in lawnmower.! A ${size} lawn: first to finish wins.`,
  },
  duel: {
    wants: MODE_WANTS.duel,
    name: 'head to head',
    match: 'match',
    share: (size) =>
      `Mow head to head with me in lawnmower.! One ${size} lawn: whoever mows more wins.`,
  },
  soccer: {
    wants: MODE_WANTS.soccer,
    name: 'soccer',
    match: 'match',
    share: (size) =>
      `Play mower soccer with me in lawnmower.! A ${size} match: kick it into my goal.`,
  },
  roundup: {
    wants: MODE_WANTS.roundup,
    name: 'round-up',
    match: 'round-up',
    share: (size) =>
      `Round up sheep with me in lawnmower.! A ${size} match: most sheep in your pen wins.`,
  },
  maze: {
    wants: MODE_WANTS.maze,
    name: 'maze',
    match: 'maze race',
    share: (size) =>
      `Race me through a hedge maze in lawnmower.! A ${size} maze: first to the star in the middle wins.`,
  },
};
